import { CountryCode } from '../enums';

export const extendedCountry = {
    [CountryCode.Belgium]: 'Belgium',
    [CountryCode.France]: 'France',
    [CountryCode.Germany]: 'Germany',
    [CountryCode.Luxembourg]: 'Luxembourg',
    [CountryCode.Netherlands]: 'Netherlands',
};
